import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import ErrorMessage from '../../components/Errors/ErrorMessage';

export function PageNotFoundPage({ t }) {
  return (
    <section className="section">
      <div className="columns">
        <div className="column is-one-third is-offset-one-third has-text-centered">
          <ErrorMessage testId="pageNotFoundPage" text={t('PAGE_NOT_FOUND')} />
        </div>
      </div>
    </section>
  );
}
PageNotFoundPage.defaultProps = {
  t: (str) => str,
};
PageNotFoundPage.propTypes = {
  t: PropTypes.func,
};
export default translate()(PageNotFoundPage);
